/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import type { HTMLAttributes } from 'react'
import React from 'react'
import { IconArrowLeft, csx } from '@vtex/admin-ui'
import type { StyleProp } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'

import { SalesAssociateMovementsTrackingModalTitle } from '../SalesAssociateMovementsTrackingModal'

const containerStyles: StyleProp = {
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  paddingY: '$space-1',
}

const titleStyles: StyleProp = {
  fontWeight: 600, // NEED_PERFORMANCE_REVIEW
  marginLeft: '$space-4',
}

export type OccurrencesModalTitleProps = {
  showGoBack: boolean
  title: string
  onClick: () => void
} & HTMLAttributes<HTMLDivElement>

export const OccurrencesModalTitle = ({
  showGoBack,
  title,
  onClick,
  ...props
}: OccurrencesModalTitleProps) => {
  const intl = useIntl()

  const handleClick = () => {
    if (showGoBack && onClick) {
      onClick()
    }
  }

  return (
    <div
      data-testid="occurrences-modal-title"
      className={csx({ ...containerStyles })}
      onClick={handleClick}
      {...props}
    >
      {showGoBack ? (
        <div className={csx({ display: 'flex' })}>
          <IconArrowLeft className={csx({ color: '$blue40' })} />
          <span className={csx({ ...titleStyles })}>
            {intl.messages.occurrencesSelectOptionTitle}
          </span>
        </div>
      ) : (
        <SalesAssociateMovementsTrackingModalTitle>
          {title}
        </SalesAssociateMovementsTrackingModalTitle>
      )}
    </div>
  )
}
